require('jquery-validation');
require('lessRoot/gift-card.less');

Blain.GiftCard = {

	init: function () {

		if (!document.getElementById("giftCard")) return;

		const $gcForm = $("#gcForm");
		const $gcDeliveryMethod1 = $("#gcDeliveryMethod1");
		const $gcDeliveryMethod2 = $("#gcDeliveryMethod2");
		const $eCardStyles = $("#eCardStyles");
		const $mailCardStyles = $("#mailCardStyles");
		const $gcInfoNumber = $("#gcInfoNumber");
		const $gcMailRecipient = $("#gcMailRecipient");
		const $gcRecip = $("#gcRecip");
		const $gcEcardFrom = $("#gcEcardFrom");
		const $gcMailTo = $("#gcMailTo");
		const $gcRecipEmail = $("#gcRecipEmail");
		const $gcRecipient1 = $("#gcRecipient1");
		const $gcRecipient2 = $("#gcRecipient2");
		const $gcRecipientZip = $("#gcRecipientZip");
		const $gcRecipientCity = $("#gcRecipientCity");
		const $gcQty = $("#gcQty");
		const $gcMsg = $("#gcMsg");
		const $gcMessage = $("#gcMessage");
		const $gcMsgLength = $("#gcMsgLength");
		const $gcStyleId = $("#gcStyleID");
		const $gcEnvelopeId = $("#gcEnvelopeID");
		let deliveryMethod = "E";
		let mailRecipient = "S";

		$eCardStyles?.find("input")?.on("click", function (e) {
			const elem = $(this);
			if (elem.is(':checked')) { //sanity
				$gcStyleId.val(elem.val());
			}
		});

		$mailCardStyles?.find("input")?.on("click", function (e) {
			const elem = $(this);
			if (elem.is(':checked')) { //sanity
				if (elem.prop('name') == "envelopeStyles") {
					$gcEnvelopeId.val(elem.val());
				} else {
					$gcStyleId.val(elem.val());
				}
			}
		});

		const updateMsgLength = function (e) {
			const maxlength = 250;
			const curlength = $gcMessage.val().length;
			const diff = maxlength - curlength;
			if (diff >= 0) {
				$gcMsgLength.text("Characters remaining: " + diff.toLocaleString());
				$gcMsgLength.removeClass("red");
			} else {
				$gcMsgLength.text("Over character limit by: " + Math.abs(diff).toLocaleString());
				$gcMsgLength.addClass("red");
			}
		};

		if ($gcDeliveryMethod2.is(":checked")) deliveryMethod = "M";
		if ($gcRecipient2.is(":checked")) mailRecipient = "O";

		$gcDeliveryMethod1.on("click", function () {
			deliveryMethod = "E";
			$eCardStyles.show();
			$mailCardStyles.hide();
			$gcEcardFrom.show();
			$gcMailRecipient.hide();
			$gcMailTo.hide();
			$gcRecip.show();
			$gcRecipEmail.show();
			$gcQty.hide();
			$gcMsg.show();
			$gcInfoNumber.text("3");
			$gcStyleId.val($eCardStyles.find("input[name=eCardStyles]:checked").val());
			$(".form-control").removeClass("valid error");
		});

		$gcDeliveryMethod2.on("click", function () {
			deliveryMethod = "M";
			$eCardStyles.hide();
			$mailCardStyles.show();
			$gcEcardFrom.hide();
			$gcMailRecipient.show();
			$gcRecipEmail.hide();
			$gcQty.show();
			$gcStyleId.val($mailCardStyles.find("input[name=mailedCardStyles]:checked").val());
			if (mailRecipient === "S") {
				$gcMsg.hide();
				$gcMessage.val("");
				$gcRecip.hide();
				$gcMailTo.hide();
			} else {
				$gcMsg.show();
				$gcRecip.show();
				$gcMailTo.show();
			}
			$gcInfoNumber.text("4");
			$(".form-control").removeClass("valid error");
		});

		$gcRecipient1.on("click", function () {
			mailRecipient = "S";
			$gcRecip.hide();
			$gcMsg.hide();
			$gcMailTo.hide();
			$(".form-control").removeClass("valid error");
		});

		$gcRecipient2.on("click", function () {
			mailRecipient = "O";
			$gcRecip.show();
			$gcMsg.show();
			$gcMailTo.show();
			$(".form-control").removeClass("valid error");
		});

		$gcMessage.on('input', updateMsgLength);

		$gcForm.validate({
			rules: {
				"gcAmount": {
					required: true,
					min: 5,
					max: 500
				},
				"gcQty": {
					required: true,
					min: 1,
					max: 200
				},
				"gcRecipientFirstName": {
					required: function() {
						return $gcRecipient2.is(":checked") || $gcDeliveryMethod1.is(":checked");
					}
				},
				"gcRecipientLastName": {
					required: function() {
						return $gcRecipient2.is(":checked") || $gcDeliveryMethod1.is(":checked");
					}
				},
				"gcRecipientAddress1": {
					required: function() {
						return $gcRecipient2.is(":checked");
					}
				},
				"gcRecipientZip": {
					required: function() {
						return $gcRecipient2.is(":checked");
					},
					digits: true,
					minlength: 5,
					maxlength: 5,
					remote: {
						type: "POST",
						url: "/a/autocitystate",
						data: {
							zipCode: function() {
								return $gcRecipientZip.val();
							},
							selectID: "gcRecipientCity",
							selectName: "gcRecipientCity"
						},
						dataFilter: function(jsonstr) {
							const json = JSON.parse(jsonstr);
							if (json.Success) {
								const $citySelect = $(json.CityListHtmlString);
								$("#gcRecipientCity").replaceWith($citySelect);
								$("#gcRecipientState").val($citySelect.data("blain-state")).change();
								return '"true"';
							}
							return '"ZIP code is invalid"';
						}
					}
				},
				"gcRecipientEmail": {
					email: true,
					required: function() {
						return $gcDeliveryMethod1.is(":checked");
					}
				},
				"gcSenderFirstName": {
					required: function() {
						return $gcDeliveryMethod1.is(":checked");
					}
				},
				"gcSenderLastName": {
					required: function() {
						return $gcDeliveryMethod1.is(":checked");
					}
				},
				"gcMessage": {
					maxlength: 250
				}
			},
			submitHandler(form) {
				$("#gcRecipientCity").prop("disabled", false);
				form.submit();
			}
		});

		updateMsgLength();

	}

};

(function($) {
	$(document).ready(function() {
		Blain.GiftCard.init();
	});
})(jQuery);